import { useState } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { LANGUAGES } from "./constants";

export function useLanguageSelector() {
  const [isOpen, setIsOpen] = useState(false);
  const { language, setLanguage } = useLanguage();

  const selectedLang = LANGUAGES.find((l) => l.code === language) || LANGUAGES[0];

  const toggleOpen = () => setIsOpen((prev) => !prev);
  const close = () => setIsOpen(false);

  const selectLanguage = (code: "he" | "en") => {
    setLanguage(code);
    close();
  };

  return {
    isOpen,
    selectedLang,
    toggleOpen,
    close,
    selectLanguage,
    languages: LANGUAGES,
  };
}
